import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { DialogRef } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TeamsService } from '../../services/teams.service';
import { AuthService } from '../../services/auth.service';
import { TeamCatalogService } from '../../services/team-catalog.service';

/**
 * De ploegenkeuze. Stond als brede keuzelijst in de kopbalk; die maakte het
 * scherm onrustig terwijl je hem hooguit eens per sessie aanraakt. Nu zit hij
 * onder het accountmenu, als een gewone lijst met vinkjes (eigenaar
 * 15-09-2026: "gewoon teams optie waar je alle teams ziet met selectievakjes").
 *
 * De keuze geldt meteen -- er is geen "Opslaan". Dat past bij hoe het eerder
 * ook werkte: aanvinken in de kopbalk filterde de lijsten direct.
 */
@Component({
  selector: 'app-teams-dialog',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './teams-dialog.component.html',
  styleUrls: ['./teams-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TeamsDialogComponent implements OnInit {
  private readonly teamsService = inject(TeamsService);
  private readonly authService = inject(AuthService);
  private readonly teamCatalog = inject(TeamCatalogService);
  private readonly dialogRef = inject(DialogRef);

  /** Alle ploegen waar deze gebruiker bij hoort. */
  public readonly teams: string[] = this.authService.user.team ?? [];

  public readonly gekozen = signal<string[]>([...(this.teamsService.teams ?? [])]);

  public readonly allesAan = () => this.gekozen().length === this.teams.length && this.teams.length > 0;

  ngOnInit(): void {
    void this.teamCatalog.ensureLoaded();
  }

  public caption(teamKey: string): string {
    return this.teamCatalog.caption(teamKey);
  }

  public isGekozen(team: string): boolean {
    return this.gekozen().includes(team);
  }

  public wissel(team: string): void {
    const huidig = this.gekozen();
    this.zet(huidig.includes(team) ? huidig.filter((t) => t !== team) : [...huidig, team]);
  }

  /** Alles aan als er nog iets uit staat, anders alles uit. */
  public wisselAlles(): void {
    this.zet(this.allesAan() ? [] : [...this.teams]);
  }

  public onClose(): void {
    this.dialogRef.close();
  }

  private zet(teams: string[]): void {
    this.gekozen.set(teams);
    this.teamsService.teams = teams;
  }
}
